import { useState, MouseEvent } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLanguageContext } from 'providers/language';
import { LANGUAGE_NAME_ENUM, getLanguageFlagSrc } from 'enums';
import { Menu, Tooltip, MenuItem, IconButton } from '@mui/material';

const LanguagePicker = () => {
  const intl = useIntl();
  const { changeLanguage } = useLanguageContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const getLanguageTranslated = (language: string) =>
    ({
      [LANGUAGE_NAME_ENUM.TURKISH]: intl.formatMessage({ id: 'language.turkish' }),
      [LANGUAGE_NAME_ENUM.ENGLISH]: intl.formatMessage({ id: 'language.english' }),
    }[language]);

  const onChangeLanguageHandler = (language: string) => {
    changeLanguage(language);
    handleClose();
  };

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={<FormattedMessage id="login.selectLanguage" defaultMessage="Dil Seçiniz" />}>
        <IconButton
          data-screenshot="change-language"
          onClick={handleClick}
          size="small"
          aria-controls={open ? 'language-picker' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}>
          <img width={25} src={getLanguageFlagSrc(intl.locale)} alt={getLanguageTranslated(intl.locale)} />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        id="language-picker"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            variant: 'outlined',
            elevation: 0,
            sx: { my: '4px' },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        {(Object.keys(LANGUAGE_NAME_ENUM) as (keyof typeof LANGUAGE_NAME_ENUM)[]).map((key, index) => (
          <MenuItem
            key={index.toString()}
            selected={intl.locale === LANGUAGE_NAME_ENUM[key]}
            value={LANGUAGE_NAME_ENUM[key]}
            onClick={() => onChangeLanguageHandler(LANGUAGE_NAME_ENUM[key])}>
            <img
              width={25}
              height={25}
              src={getLanguageFlagSrc(LANGUAGE_NAME_ENUM[key])}
              alt={getLanguageTranslated(LANGUAGE_NAME_ENUM[key])}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguagePicker;
